import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import { BiPlusMedical, BiTrash, BiEdit } from "react-icons/bi";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ring2 } from 'ldrs';
import { dotWave } from 'ldrs'
import "./roles.css";
import "../css/globalCss.css";
import { BsPersonGear } from "react-icons/bs";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cookies from 'js-cookie';
import { decryptData } from "../../../Auth/cryptage";



function PermissionsList() {
    const MySwal = withReactContent(Swal);
    const [roles, setRoles] = useState([]);
    const [filteredRoles, setFilteredRoles] = useState([]);
    const [loading, setLoading] = useState({
        who: '',
        status: false,
        userId: null
    });
    
    dotWave.register()
    ring2.register();

    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);
    useEffect(() => {
        document.title = "GecimmoIA - Roles";
    }, []);
    const getRolesData = async () => {
        try {
            setLoading({
                who: 'roles',
                status: true,
                userId: null
            });
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get('https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/roles', {
                headers: {
                    'X-Custom-Token': token
                }
            });
            console.log(result.data.roles);
            setRoles(result.data.roles );
            setFilteredRoles(result.data.roles);
        } catch (error) {
            console.error("Error fetching users: ", error);
            setLoading({
                who: 'roles',
                status: false,
                userId: null
            });
        } finally {
            setLoading({
                who: 'roles',
                status: false,
                userId: null
            });
        }
    };
    const Search = (searchTerm) => {
        const lowercased = searchTerm.toLowerCase();
        // // console.log()()
        const filteredData = roles.filter((role) =>
            Object.keys(role).some((key) => {
                const value = role[key];
                if (Array.isArray(value)) {
                    return value.some(item => 
                        Object.values(item).some(val => String(val).toLowerCase().includes(lowercased))
                    );
                }
                return String(value).toLowerCase().includes(lowercased);
            })
        );
    
        setFilteredRoles(filteredData);
    };
    
    const isArrayEmpty = (arr) => !Array.isArray(arr) || arr.length === 0;

    const deleteRole = async (id) => {
        try {
            const result = await MySwal.fire({
                title: "Êtes-vous sûr ?",
                text: "Vous ne pourrez pas annuler cela !",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Oui, supprimez-le !",
                cancelButtonText: "Annuler"
            });

            if (result.isConfirmed) {
                setLoading({
                    who: 'delete',
                    status: true,
                    userId: id
                });
                const token = decryptData(Cookies.get('access_token'));
                await axios.delete(`https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/destroy-role/${id}`, {
                    headers: {
                        'X-Custom-Token': token
                    }
                });
                MySwal.fire({
                    title: "Supprimé !",
                    text: "Le rôle a été supprimé.",
                    icon: "success"
                });
                getRolesData();
            }
        } catch (err) {
            setLoading({
                who: 'delete',
                status: false,
                userId: null
            });
            MySwal.fire({
                title: "Erreur !",
                text: err.message,
                icon: "error"
            });
        } finally {
            setLoading({
                who: 'delete',
                status: false,
                userId: null
            });
        }
    };

    useEffect(() => {
        getRolesData();
    }, []);


    return (
        <>
            <Container>
                <Row data-aos="fade-left" className='my-4'>
                    <Col>
                        <h1>
                            <BsPersonGear className='mb-2 mx-2' />
                            Roles
                        </h1>
                    </Col>
                    <Col className="d-flex justify-content-center align-items-center">
                        <Link to='/dashboard/roles/create-role' className="CreatePermissionBtn btn btn-primary">
                            <span>Créer une role</span>
                            <BiPlusMedical className="CreatePermissionBtnIcon" />
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        <div className="containerSearch">
                            <input className="checkboxSearch" type="checkbox" />
                            <div className="mainboxSearch">
                                <div className="iconContainerSearch">
                                    <svg
                                        viewBox="0 0 512 512"
                                        height="1em"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="search_icon mb-1"
                                    >
                                        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                                    </svg>
                                </div>
                                <input
                                    className="search_input"
                                    placeholder="Recherche"
                                    type="text"
                                    onChange={(e) => Search(e.target.value)}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Table striped bordered hover responsive className="text-center align-middle custom-table">
                        <thead data-aos="fade-down" className="thead-dark">
                            <tr>
                                <th>#Id</th>
                                <th>Role</th>
                                <th>Permissions</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody data-aos="fade-up">
                            {loading.status && loading.who === "roles" ? (
                                <tr>
                                    <td colSpan="4">
                                        <l-dot-wave size="47" speed="1" color="black"></l-dot-wave>
                                    </td>
                                </tr>
                            ) : isArrayEmpty(filteredRoles) ? (
                                <tr>
                                    <td colSpan="7" className="text-center">
                                        Not Found
                                    </td>
                                </tr>
                                ) :(
                                    filteredRoles.map((role) => (
                                    <tr key={role.id}>
                                        <td>{role.id}</td>
                                        <td>{role.name}</td>
                                        <td>
                                            {role.permissions.length === 0 ? "Not given" : (
                                                <ul className="list-group">
                                                    {role.permissions.map((permission) => (
                                                        <li key={permission.id} className="list-group-item">
                                                            {permission.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </td>
                                        <td className="d-flex justify-content-around">
                                            <Button variant="danger" onClick={() => deleteRole(role.id)}>
                                                {loading.status && loading.who === "delete" && loading.userId === role.id ? (
                                                    <l-ring-2
                                                        size="25"
                                                        stroke="3"
                                                        stroke-length="0.25"
                                                        bg-opacity="0.1"
                                                        speed="0.8"
                                                        color="white"
                                                    ></l-ring-2>
                                                ) : (
                                                    <BiTrash className="btn-icon" />
                                                )}
                                            </Button>
                                            <Link to={`/dashboard/roles/update-role/${role.id}`} className='btn btn-success'>
                                                <BiEdit className="btn-icon" />
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Row>
            </Container>
        </>
    );
}

export default PermissionsList;